import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { useMenu } from '../../hooks/useMenu';
import Paragraph from '../../components/Paragraph/Paragraph';
import MetalStreamAllocateForm from '../../components/Forms/MetalStreamAllocateForm';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { Heading } from '../../components/Heading';
import themeColors from '../../assets/styles/themeColors';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const MetalStreamAllocate = () => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const { BrokerName } = useSelector(selectSettings);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
    >
      <Helmet>
        <title>
          {t('metalstream.titleTagAllocation', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={12}>{t('metalstream.allocateTitle')}</Heading>
      <Paragraph mb={32} color={themeColors.colorTextXLLight}>
        {t('metalstream.allocateSubtitle')}
      </Paragraph>
      <MetalStreamAllocateForm nextPath={activeItem?.nextPath} />
    </OnBoardingContainer>
  );
};

export default MetalStreamAllocate;
